import './Progress.c99f32b37dc1092c8c75db167794c968.css';
export default {"progress":"_progress_lwu1a_1","inverted":"_inverted_lwu1a_1"};